module.exports = {

    "bankOfBarodaOfferConfig":{
        platinumDebitCard:['offer_MgUrujnRhDX5YO', 'offer_MgVJP8hqbVElzZ', 'offer_MgVL0Ppct8AbTp'],
        sapphireDebitCard:['offer_MgVPZqBWPbH0ra'],
        opulenceDebitCard:['offer_MgVNhk7gtLGYWV']
    }
}
